import { insertSpace, getNode, setActiveTool, isPositiveNumber } from "../../../commands/custom-commands";
import { customSchema } from "../../../schemas/custom-schema";

export default class SpaceTool {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.originalView = editorView;
    this.buildContainer();
    this.buildDialog();
    this.bindActions();
    containerElement.appendChild(this.containerElement);
    this.update(editorView);
  }

  buildContainer() {
    this.containerElement = document.createElement("div");
    this.containerElement.className = "editor-button-container";
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button";
    this.buttonElement.style.anchorName ="--space-anchor";
    this.buttonElement.dataset.action = "space";
    this.buttonElement.setAttribute("aria-expanded", "false");
    this.buttonElement.title = "Espaciado";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Espaciado";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Espaciado";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.containerElement.appendChild(this.buttonElement);
  }

  buildDialog() {
    const targetInputContainer = document.createElement("div"),
      sizeLabel = document.createElement("label"),
      sizeContainer = document.createElement("div"),
      buttonsContainer = document.createElement("div");

    this.dialogElement = document.createElement("div");
    this.dialogElement.className = "editor-dialog";
    this.dialogElement.style.positionAnchor = "--space-anchor";
    this.sizeInput = document.createElement("input");
    this.sizeInput.className = "editor-input";
    this.sizeInput.setAttribute("type", "number");
    this.sizeInput.setAttribute("min", "0.1");
    this.sizeInput.setAttribute("placeholder", "Medida base: 1ch");
    
    sizeLabel.className = "editor-dialog-label";
    sizeLabel.textContent = "Tamaño";
    sizeContainer.className = "editor-dialog-container";
    sizeContainer.appendChild(sizeLabel);
    sizeContainer.appendChild(this.sizeInput);

    this.submitButton = document.createElement("button");
    this.submitButton.type = "button";
    this.submitButton.className = "editor-button";
    this.submitButton.textContent = "Agregar";

    buttonsContainer.className = "editor-buttons-container";
    buttonsContainer.appendChild(this.submitButton);

    this.dialogElement.appendChild(sizeContainer);
    this.dialogElement.appendChild(buttonsContainer);

    this.containerElement.appendChild(this.dialogElement);
  }

  bindActions() {
    this.buttonAction = this.buttonClickCallback();
    this.submitAction = this.submitButtonClickCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.submitButton.addEventListener("click", this.submitAction);
  }

  update(view) {
    const node = getNode(view.state, customSchema.nodes.space),
      nodeAttrs = node?.attrs,
      isEnabled = insertSpace(null)(view.state, null);
    if(!!node) { 
      this.sizeInput.value = node.attrs.size;
      this.buttonElement.setAttribute("aria-pressed", "true");
    } else {
      this.sizeInput.value = null;
      this.buttonElement.setAttribute("aria-pressed", "false");
    }

    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.submitButton.removeEventListener("submit", this.submitAction);
    this.containerElement.remove();
    this.containerElement = null;
    this.buttonElement = null;
    this.sizeInput = null;
    this.submitButton = null;
    this.dialogElement = null;
    this.buttonAction = null;
    this.submitAction = null;
  }

  buttonClickCallback() {
    return () => {
      setActiveTool(this.buttonElement)(this.originalView.state, this.originalView.dispatch);
    }
  }

  submitButtonClickCallback() {
    return (event) => {
      event.preventDefault();
      const { value: size } = this.sizeInput;

      if(!isPositiveNumber(size)) {
        alert("Tamaño no válido. Debe ser positivo");

        return false;
      }

      insertSpace(size)(this.view.state, this.view.dispatch, this.view);
      this.view.focus();
    }
  }
}
